//React
import React from 'react'

//Gatsby
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

//Actions
import FeatureIcon from '../marketing/featureIcon'
import PreviewVideo from '../elements/previewVideo'

const formatDescription = (descriptionText) => (
  <React.Fragment>
    {descriptionText.split('\n').map((line, i) => (
      <span key={i}>
        {line}
        <br />
      </span>
    ))}
  </React.Fragment>
)

const getVideoSource = (videosource) => {
  switch (videosource) {
    default:
      return 'https://picohealth.s3.amazonaws.com/static/web/picohealth-overview-video.mp4'
  }
}
const Snippet = (props) => (
  <StaticQuery
    query={graphql`
      query {
        featureOnboarding: file(
          relativePath: { eq: "feature/onboarding-text-start.png" }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: NORTH) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        featureScreening: file(
          relativePath: { eq: "feature/screening-survey-employee.png" }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: NORTH) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        featureScreeningNextsteps: file(
          relativePath: { eq: "feature/screening-nextsteps-evaluate.png" }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: NORTH) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseTravelSolution: file(
          relativePath: {
            eq: "stock/unsplash/louis-hansel-shotsoflouis-wVoP_Q2Bg_A-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: NORTH) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseTravel: file(
          relativePath: {
            eq: "stock/unsplash/claire-ward-Fy9JXanwJi0-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: EAST
              quality: 80
              duotone: { highlight: "#56849e", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseRetailSolution: file(
          relativePath: {
            eq: "stock/unsplash/bbh-singapore-HqhSi1Otubo-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: NORTH) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseRetail: file(
          relativePath: {
            eq: "stock/unsplash/clark-street-mercantile-P3pI6xzovu0-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: EAST
              quality: 80
              duotone: { highlight: "#f2ce16", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseAthleticClubSolution: file(
          relativePath: {
            eq: "stock/unsplash/matthew-lejune-A3EOQ8sP3fY-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: CENTER) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseAthleticClub: file(
          relativePath: {
            eq: "stock/unsplash/victor-freitas-hOuJYX2K5DA-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: EAST
              quality: 80
              duotone: { highlight: "#07b2d9", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseRestaurant: file(
          relativePath: {
            eq: "stock/unsplash/bundo-kim-Pb9bUzH1nD8-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: EAST
              quality: 80
              duotone: { highlight: "#f5aa00", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseRestaurantSolution: file(
          relativePath: {
            eq: "stock/unsplash/peter-dawn-mM-L0yx5LcQ-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: CENTER) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseConstruction: file(
          relativePath: {
            eq: "stock/unsplash/daniel-mccullough-HtBlQdxfG9k-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: CENTER
              quality: 80
              duotone: { highlight: "#40a0b5", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseConstructionSolution: file(
          relativePath: {
            eq: "stock/unsplash/charles-deluvio-Za9oagRJNLM-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: CENTER) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseHomehealth: file(
          relativePath: {
            eq: "stock/unsplash/national-cancer-institute-BxXgTQEw1M4-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(
              width: 240
              height: 260
              cropFocus: CENTER
              quality: 80
              duotone: { highlight: "#40a0b5", shadow: "#1d1a08" }
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usecaseHomehealthSolution: file(
          relativePath: {
            eq: "stock/unsplash/hush-naidoo-pA0uoltkwao-unsplash.jpg"
          }
        ) {
          childImageSharp {
            fixed(width: 240, height: 260, cropFocus: CENTER) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `}
    render={(data) => (
      <>
        {props.featureData.map((item, i) => (
          <>
            {i % 2 !== 0 ? (
              <>
                <div
                  class={`py-3 ${item.bgcolor ? `bg-${item.bgcolor}` : ''} ${
                    item.bggradient ? `gradient-callout-${item.bggradient}` : ''
                  }`}
                >
                  {' '}
                  <div
                    class={`container container-alt-callout d-flex align-items-center justify-content-center ${
                      item.bgcolor ? `m-0` : ''
                    }`}
                  >
                    <div class={`row ${!item.bgcolor ? `alt-callout` : ''}`}>
                      <div
                        class={`col-lg-4 offset-xs-0 offset-lg-2 mb-3 d-flex align-items-center justify-content-center ${
                          item.image ? 'alt-image-sizer' : ''
                        }`}
                      >
                        {item.image ? (
                          <Img
                            alt={item.title}
                            className={`rounded-corners`}
                            fixed={data[item.image].childImageSharp.fixed}
                          />
                        ) : null}
                        {item.videosource ? (
                          <div
                            class="d-flex align-items-center justify-content-center justify-content-lg-end p-4"
                            style={{ display: 'flex' }}
                          >
                            <PreviewVideo
                              videosource={getVideoSource(item.videosource)}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div class="col-lg-6 d-flex">
                        <div
                          class={`feature-${i} ml-0 ml-lg-1 d-flex flex-column align-items-center align-items-lg-start justify-content-center flex-grow-1`}
                        >
                          {item.iconShow ? (
                            <div class="feature-icon-container feature-icon-container-left">
                              {item.iconContext ? (
                                <FeatureIcon
                                  context={item.iconContext}
                                  color={item.iconColor}
                                />
                              ) : (
                                <FeatureIcon
                                  text={i + 1}
                                  color={item.iconColor}
                                />
                              )}
                            </div>
                          ) : null}
                          <div class="d-flex flex-column align-items-center align-items-lg-start justify-content-lg-center text-center text-lg-left">
                            <h2
                              class={`font-weight-${
                                item.titleWeight ? item.titleWeight : 'light'
                              } ${
                                item.titleColor ? item.titleColor : 'black-1'
                              }`}
                            >
                              {item.title}
                            </h2>
                            <p
                              class={`lead ${
                                item.descriptionColor
                                  ? item.descriptionColor
                                  : 'black-1'
                              }`}
                            >
                              {formatDescription(item.description)}
                            </p>{' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* {item.lineClass ? (
                  <DividerMid
                    class="transparent-1"
                    bottomclass="transparent-4"
                    flip={false}
                    lineclass={item.lineClass}
                    lineoffset={4}
                    lineflip={true}
                  />
                ) : null} */}
              </>
            ) : (
              <>
                <div
                  class={`py-3 ${item.bgcolor ? `bg-${item.bgcolor}` : ''} ${
                    item.bggradient ? `gradient-callout-${item.bggradient}` : ''
                  }  d-flex align-items-center justify-content-center `}
                >
                  {' '}
                  <div
                    class={`container container-alt-callout d-flex align-items-center justify-content-center ${
                      item.bgcolor ? `m-0` : ''
                    }`}
                  >
                    <div
                      class={`row feature-detail-reverse ${
                        !item.bgcolor ? `alt-callout` : ''
                      }`}
                    >
                      <div class="col-lg-6 d-flex">
                        <div
                          class={`feature-${i} mr-0 mr-lg-1 d-flex flex-column align-items-center align-items-lg-end justify-content-center flex-grow-1`}
                        >
                          {item.iconShow ? (
                            <div class="feature-icon-container feature-icon-container-right">
                              {item.iconContext ? (
                                <FeatureIcon
                                  context={item.iconContext}
                                  color={item.iconColor}
                                />
                              ) : (
                                <FeatureIcon
                                  text={i + 1}
                                  color={item.iconColor}
                                />
                              )}
                            </div>
                          ) : null}
                          <div class="d-flex flex-column align-items-center align-items-lg-end justify-content-center text-center text-lg-right">
                            <h2
                              class={`font-weight-${
                                item.titleWeight ? item.titleWeight : 'light'
                              } ${
                                item.titleColor ? item.titleColor : 'black-1'
                              }`}
                            >
                              {item.title}
                            </h2>
                            <p
                              class={`lead ${
                                item.descriptionColor
                                  ? item.descriptionColor
                                  : 'black-1'
                              }`}
                            >
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class={`col-lg-4 d-flex align-items-center justify-content-center ${
                          item.image ? 'alt-image-sizer' : ''
                        }`}
                      >
                        {item.image ? (
                          <Img
                            alt={item.title}
                            className={`rounded-corners`}
                            fixed={data[item.image].childImageSharp.fixed}
                          />
                        ) : null}
                        {item.videosource ? (
                          <div
                            class="d-flex align-items-center justify-content-center justify-content-lg-end p-4"
                            style={{ display: 'flex' }}
                          >
                            <PreviewVideo videosource="https://storylavamedia.s3.amazonaws.com/static/media/video-1.mp4" />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {/* {item.lineClass ? (
                  <DividerMid
                    class={item.bgcolor ? "white-1" : "transparent-1"}
                    bottomclass={item.bgcolor ? item.bgcolor : "transparent-1"}
                    flip={false}
                    lineclass={item.lineClass}
                    lineoffset={4}
                    lineflip={false}
                  />
                ) : null} */}
              </>
            )}
          </>
        ))}
      </>
    )}
  />
)

export default Snippet
